import type { FC } from 'react';

import { StorefrontContainer } from '@/features/storefront/components/StorefrontContainer';
import {
  HeaderBannerRail,
  MegaMenuBar,
  MenuLink,
  StoreLogo,
} from '@/features/storefront/layouts/chrome/ChromeParts';
import {
  CHROME_QUIET_SCROLL,
  menuItems,
  type HeaderProps,
} from '@/features/storefront/layouts/chrome/types';
import { cn } from '@/lib/cn';

/** Two decks: a slim utility row, then a heavyweight wordmark and a nav bar. */
export const Header: FC<HeaderProps> = ({ storeName, logoUrl, header, menu, endSlot, preview }) => {
  const items = menuItems(menu);
  return (
    <header
      className={cn(header.sticky && !preview && 'sticky top-0 z-40')}
      style={{ backgroundColor: 'var(--storefront-background)' }}
    >
      <HeaderBannerRail header={header} preview={preview} />
      <StorefrontContainer className="flex h-10 items-center justify-end gap-5 text-sm">
        {endSlot}
      </StorefrontContainer>
      <StorefrontContainer className="flex items-center justify-between pb-4 pt-1">
        <StoreLogo
          storeName={storeName}
          logoUrl={logoUrl}
          logoWidthPx={header.logo_width_px}
          showStoreName={header.show_store_name}
          preview={preview}
          nameClassName="text-3xl font-black uppercase tracking-tight sm:text-4xl"
          className="gap-3"
        />
      </StorefrontContainer>
      <div style={{ backgroundColor: 'var(--storefront-primary)' }}>
        {items.length > 0 ? (
          <StorefrontContainer>
            <nav
              aria-label={menu?.name}
              className={cn(
                'flex items-center gap-6 overflow-x-auto py-2.5 text-sm font-bold uppercase tracking-wide',
                CHROME_QUIET_SCROLL,
              )}
              style={{ color: 'var(--storefront-background)' }}
            >
              {items.map((item) => (
                <MenuLink
                  key={`${item.label}:${item.url}`}
                  item={item}
                  preview={preview}
                  className="whitespace-nowrap hover:opacity-80"
                />
              ))}
            </nav>
          </StorefrontContainer>
        ) : (
          <div className="h-1.5" />
        )}
      </div>
      <MegaMenuBar header={header} preview={preview} />
    </header>
  );
};
